"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSrt = void 0;
function toSeconds(time) {
    const [first, second, third] = time.split(':');
    if (!first) {
        throw new Error(`Invalid timestamp:${time}`);
    }
    if (!second) {
        throw new Error(`Invalid timestamp:${time}`);
    }
    if (!third) {
        throw new Error(`Invalid timestamp:${time}`);
    }
    const [seconds, millis] = third.split(',');
    if (!seconds) {
        throw new Error(`Invalid timestamp:${time}`);
    }
    if (!millis) {
        throw new Error(`Invalid timestamp:${time}`);
    }
    return (parseInt(first, 10) * 3600 +
        parseInt(second, 10) * 60 +
        parseInt(seconds, 10) +
        parseInt(millis, 10) / 1000);
}
const parseSrt = ({ input }) => {
    const inputLines = input.split('\n');
    const captions = [];
    for (let i = 0; i < inputLines.length; i++) {
        const line = inputLines[i];
        const nextLine = inputLines[i + 1];
        if ((line === null || line === void 0 ? void 0 : line.match(/([0-9]+)/)) && (nextLine === null || nextLine === void 0 ? void 0 : nextLine.includes(' --> '))) {
            const nextLineSplit = nextLine.split(' --> ');
            const start = toSeconds(nextLineSplit[0]);
            const end = toSeconds(nextLineSplit[1]);
            captions.push({
                text: '',
                startMs: start * 1000,
                endMs: end * 1000,
                confidence: 1,
                timestampMs: ((start + end) / 2) * 1000,
            });
        }
        else if (line === null || line === void 0 ? void 0 : line.includes(' --> ')) {
            continue;
        }
        else if ((line === null || line === void 0 ? void 0 : line.trim()) === '') {
            captions[captions.length - 1].text = captions[captions.length - 1].text.trim();
        }
        else {
            captions[captions.length - 1].text += line + '\n';
        }
    }
    return {
        captions: captions.map((l) => {
            return {
                ...l,
                text: l.text.trimEnd(),
            };
        }),
    };
};
exports.parseSrt = parseSrt;
